import { getCookie } from "./CookieManager";

export const jwtHeader = () => {
    return {
        "accept": "application/json",
        "Authorization": `Bearer ${getCookie('desk_reg_jwt')}`
    }
}
